export default __webpack_public_path__ + "static/0bf4f3ea6419c5509ca2451cf732991a.jpg";